<template>
  <MainContainer />
</template>

<script>
import MainContainer from "./containers/MainContainer.vue";
import { mapGetters } from "vuex";

export default {
  name: "change-password",
  components: {
    MainContainer,
  },
  mounted() {
    if (this.getUserEmail.length < 8 || this.getUserPassword.length < 8) {
      this.$router.push({ path: "signin" });
      return;
    }
  },
  computed: mapGetters(["getUserEmail", "getUserPassword"]),
};
</script>
